import { useEffect } from 'react'

import {
  emiBanksData,
  emiPopup,
  fetchEmiBanksData,
  selectedFlightData,
  setEmiBanksData,
  setEmiPopup,
} from '@/redux/slices/emiAffordability'
import { useAppDispatch, useAppSelector } from '@/redux/store/hooks'

import EmiOptions from '@/components/itinerary/Aside/EmiBlock/EmiOptions'
import { isEmpty } from '@/utils/general/browserHelper'
import { isFeatureEnabled } from '@/utils/general/uiHelper'
import { commonPayloadPartFf } from '@/utils/srp/emi'

const SrpEmiBanksPopup = ({ searchQuery = {}, searchData = {} }) => {
  const dispatch = useAppDispatch()
  const selectedFlight = useAppSelector(selectedFlightData)
  const emiData = useAppSelector(emiBanksData)
  const emiPopupDetails = useAppSelector(emiPopup)
  const { show: openEmiPlans } = emiPopupDetails || {}
  const { noCostEmi = {} } = isFeatureEnabled() || {}
  const { flight_list = [], emi_providers = [], loading, error } = emiData || {}
  const { eligibility_list = [] } = flight_list?.[0] || {}
  const emiCallout = eligibility_list?.[0] || {}
  const processingFeeMsg = emiCallout?.processing_fee_message || ''

  useEffect(() => {
    if (openEmiPlans) {
      getEmiBanksData()
    }
  }, [openEmiPlans])

  const toggleEmiPopup = (show: boolean) => {
    dispatch(
      setEmiPopup({
        show,
      })
    )
  }

  const getEmiBanksData = () => {
    try {
      dispatch(setEmiBanksData({}))
      const payload = {
        ...(commonPayloadPartFf(searchQuery, noCostEmi) || {}),
        sid: searchData.dataId,
        request_mode: 'FULL',
        flight_list: [
          {
            uuid: selectedFlight?.uuid,
            amount: selectedFlight?.amount,
          },
        ],
      }
      dispatch(fetchEmiBanksData(payload))
    } catch (e) {
      dispatch(setEmiBanksData({ error: true }))
    }
  }
  return (
    <EmiOptions
      emiOptionsData={emi_providers}
      handleRetry={getEmiBanksData}
      isError={!isEmpty(error)}
      isLoading={loading}
      openEmiPlans={openEmiPlans}
      processingFeeMsg={processingFeeMsg}
      setOpenEmiPlans={toggleEmiPopup}
    />
  )
}

export default SrpEmiBanksPopup
